var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            "before-close": _vm.handleClose,
            "destroy-on-close": true,
            direction: _vm.direction,
            modal: true,
            title: _vm.config.title,
            visible: _vm.drawer,
            "with-header": false,
            "wrapper-closable": true,
            size: "700px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c("div", { staticClass: "role-box" }, [
            _c("div", { staticClass: "table-box" }, [
              _c(
                "span",
                {
                  class: { on: _vm.activeName == 0 },
                  on: {
                    click: function ($event) {
                      _vm.activeName = 0
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.config.title))]
              ),
              _vm._v(" "),
              _c("i", {
                staticClass: "el-icon-close",
                on: { click: _vm.handleClose },
              }),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeName == 0,
                    expression: "activeName == 0",
                  },
                ],
                staticClass: "card-box",
              },
              [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: {
                      model: _vm.formData,
                      rules: _vm.rules,
                      "label-width": "80px",
                      size: "small",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("setting.edit.departmentname") + "：",
                          prop: "name",
                        },
                      },
                      [
                        _c("el-input", {
                          staticClass: "input-item",
                          attrs: {
                            placeholder: _vm.$t("setting.edit.inputcontent"),
                            size: "small",
                          },
                          model: {
                            value: _vm.formData.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "name", $$v)
                            },
                            expression: "formData.name",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "父级部门：" } },
                      [
                        _c("el-cascader", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            disabled: _vm.config.disabled,
                            options: _vm.parentTreeList,
                            props: { checkStrictly: true },
                            size: "small",
                          },
                          on: { change: _vm.handleChange },
                          model: {
                            value: _vm.formData.path,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "path", $$v)
                            },
                            expression: "formData.path",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "默认角色：", prop: "role_id" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "请选择默认角色" },
                            model: {
                              value: _vm.formData.role_id,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "role_id", $$v)
                              },
                              expression: "formData.role_id",
                            },
                          },
                          _vm._l(_vm.roleList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.role_name, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "部门主管：" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: _vm.$t("setting.edit.selectmembers"),
                              disabled: "",
                              multiple: "",
                              size: "small",
                            },
                            on: { change: _vm.handleChangeframe },
                            model: {
                              value: _vm.frameValue,
                              callback: function ($$v) {
                                _vm.frameValue = $$v
                              },
                              expression: "frameValue",
                            },
                          },
                          _vm._l(_vm.frameOptions, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "部门排序：" } },
                      [
                        _c("el-input-number", {
                          attrs: {
                            min: 0,
                            pprecision: 0,
                            "controls-position": "right",
                            size: "small",
                          },
                          on: { change: _vm.handleChange },
                          model: {
                            value: _vm.formData.sort,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "sort", $$v)
                            },
                            expression: "formData.sort",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label:
                            _vm.$t("setting.edit.departmentintroduction") +
                            "：",
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            autosize: { minRows: 6 },
                            maxlength: "250",
                            placeholder: "请输入部门简介",
                            resize: "none",
                            "show-word-limit": "",
                            type: "textarea",
                          },
                          model: {
                            value: _vm.formData.introduce,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "introduce", $$v)
                            },
                            expression: "formData.introduce",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "from-foot-btn fix btn-shadow" },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.close } },
                [_vm._v(_vm._s(_vm.$t("public.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.onSubmit },
                },
                [_vm._v(_vm._s(_vm.$t("public.save")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }